"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveDesktopTabs from "../MyStreamWaveDesktopTabs";
import { useContentTab } from "@/components/brain/ContentTabContext";
import MemesArtSubmissionModal from "@/components/waves/memes/MemesArtSubmissionModal";
import MyStreamWaveTabsMemeSubmit from "./MyStreamWaveTabsMemeSubmit";
import { useWave } from "../../../../hooks/useWave";
import { useDecisionPoints } from "../../../../hooks/waves/useDecisionPoints";
import { Time } from "../../../../helpers/time";
import type { TimeLeft } from "../../../../helpers/waves/time.utils";
import { calculateTimeLeft } from "../../../../helpers/waves/time.utils";
import { CompactTimeCountdown } from "../../../waves/leaderboard/time/CompactTimeCountdown";
import { useSidebarState } from "../../../../hooks/useSidebarState";
import { ChevronDoubleLeftIcon, ArrowLeftIcon, MagnifyingGlassIcon, ShareIcon, LinkIcon, CheckIcon } from "@heroicons/react/24/outline";
import WavePicture from "../../../waves/WavePicture";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { createBreakpoint } from "react-use";
import WaveDropsSearchModal from "@/components/waves/drops/search/WaveDropsSearchModal";
import { MyStreamWaveTab } from "@/types/waves.types";
import { useWaveChatScrollOptional } from "@/contexts/wave/WaveChatScrollContext";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveHomeRoute } from "@/helpers/navigation.helpers";
import { useWaveShareCopyAction } from "@/hooks/waves/useWaveShareCopyAction";
const useBreakpoint = createBreakpoint({
  LG: 1024,
  S: 0
});
interface MyStreamWaveTabsMemeProps {
  readonly wave: ApiWave;
}
const MyStreamWaveTabsMeme: React.FC<MyStreamWaveTabsMemeProps> = t0 => {
  const $ = _c(96);
  const {
    wave
  } = t0;
  const {
    activeContentTab,
    setActiveContentTab
  } = useContentTab();
  const {
    toggleRightSidebar,
    isRightSidebarOpen
  } = useSidebarState();
  const [isMemesModalOpen, setIsMemesModalOpen] = useState(false);
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const {
    isApp
  } = useDeviceInfo();
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "S";
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const waveChatScroll = useWaveChatScrollOptional();
  const isDirectMessage = wave.chat.scope.group?.is_direct_message ?? false;
  const showShareAction = !isDirectMessage;
  let t1;
  if ($[0] !== isDirectMessage || $[1] !== wave.id || $[2] !== wave.name) {
    t1 = {
      waveId: wave.id,
      waveName: wave.name,
      isDirectMessage
    };
    $[0] = isDirectMessage;
    $[1] = wave.id;
    $[2] = wave.name;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    mode: waveLinkActionMode,
    label: waveLinkActionLabel,
    feedbackState: waveLinkActionFeedbackState,
    onClick: handleWaveLinkActionClick
  } = useWaveShareCopyAction(t1);
  const waveLinkActionIconColor = waveLinkActionFeedbackState === "idle" ? "tw-text-iron-200" : "tw-text-emerald-300";
  let t2;
  if ($[4] !== waveLinkActionFeedbackState || $[5] !== waveLinkActionMode) {
    t2 = () => {
      if (waveLinkActionFeedbackState !== "idle") {
        return <CheckIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" />;
      }
      if (waveLinkActionMode === "share") {
        return <ShareIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" />;
      }
      return <LinkIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" />;
    };
    $[4] = waveLinkActionFeedbackState;
    $[5] = waveLinkActionMode;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const renderWaveLinkActionIcon = t2;
  const {
    isMemesWave,
    isRankWave,
    pauses: t3
  } = useWave(wave);
  const {
    filterDecisionsDuringPauses
  } = t3;
  const {
    allDecisions
  } = useDecisionPoints(wave);
  let t4;
  if ($[7] !== allDecisions || $[8] !== filterDecisionsDuringPauses) {
    const decisionsAsApiFormat = allDecisions.map(_temp);
    const filtered = filterDecisionsDuringPauses(decisionsAsApiFormat);
    t4 = allDecisions.filter(decision_0 => filtered.some(f => f.decision_time === decision_0.timestamp));
    $[7] = allDecisions;
    $[8] = filterDecisionsDuringPauses;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const filteredDecisions = t4;
  let t5;
  if ($[10] !== filteredDecisions) {
    t5 = filteredDecisions.find(_temp2)?.timestamp ?? null;
    $[10] = filteredDecisions;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const nextDecisionTime = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const [timeLeft, setTimeLeft] = useState(t6);
  let t7;
  let t8;
  if ($[13] !== nextDecisionTime) {
    t7 = () => {
      if (!nextDecisionTime) {
        return;
      }
      setTimeLeft(calculateTimeLeft(nextDecisionTime));
      const intervalId = setInterval(() => {
        const newTimeLeft = calculateTimeLeft(nextDecisionTime);
        setTimeLeft(newTimeLeft);
        if (newTimeLeft.days === 0 && newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
          clearInterval(intervalId);
        }
      }, 1000);
      return () => clearInterval(intervalId);
    };
    t8 = [nextDecisionTime];
    $[13] = nextDecisionTime;
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  useEffect(t7, t8);
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setIsMemesModalOpen(true);
    };
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const handleMemesSubmit = t9;
  let t10;
  if ($[17] !== isApp || $[18] !== router || $[19] !== searchParams || $[20] !== wave.chat.scope.group?.is_direct_message) {
    t10 = () => {
      const params = new URLSearchParams(searchParams?.toString() || "");
      params.delete("wave");
      params.delete("serialNo");
      params.delete("divider");
      params.delete("drop");
      const basePath = getWaveHomeRoute({
        isDirectMessage: wave.chat.scope.group?.is_direct_message ?? false,
        isApp
      });
      const newUrl = params.toString() ? `${basePath}?${params.toString()}` : basePath;
      router.push(newUrl, {
        scroll: false
      });
    };
    $[17] = isApp;
    $[18] = router;
    $[19] = searchParams;
    $[20] = wave.chat.scope.group?.is_direct_message;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const handleMobileBack = t10;
  let t11;
  if ($[22] !== pathname || $[23] !== router || $[24] !== searchParams || $[25] !== setActiveContentTab || $[26] !== wave.id || $[27] !== waveChatScroll) {
    t11 = serialNo => {
      setActiveContentTab(MyStreamWaveTab.CHAT);
      if (waveChatScroll) {
        waveChatScroll.requestScrollToSerialNo({
          waveId: wave.id,
          serialNo
        });
        return;
      }
      const params_0 = new URLSearchParams(searchParams?.toString() || "");
      params_0.set("serialNo", String(serialNo));
      router.replace(`${pathname}?${params_0.toString()}`, {
        scroll: false
      });
    };
    $[22] = pathname;
    $[23] = router;
    $[24] = searchParams;
    $[25] = setActiveContentTab;
    $[26] = wave.id;
    $[27] = waveChatScroll;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const handleSearchSelect = t11;
  let t12;
  if ($[29] !== handleMobileBack || $[30] !== isMobile) {
    t12 = isMobile && <button onClick={handleMobileBack} className="-tw-ml-2.5 tw-mr-1.5 tw-flex tw-h-full tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-px-2.5 tw-text-iron-300 tw-transition-colors hover:tw-text-iron-50" aria-label="Go back"><ArrowLeftIcon className="tw-h-6 tw-w-6 tw-flex-shrink-0" /></button>;
    $[29] = handleMobileBack;
    $[30] = isMobile;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== handleWaveLinkActionClick || $[33] !== isMobile || $[34] !== renderWaveLinkActionIcon || $[35] !== showShareAction || $[36] !== wave.contributors_overview || $[37] !== wave.name || $[38] !== wave.picture || $[39] !== waveLinkActionIconColor || $[40] !== waveLinkActionLabel || $[41] !== waveLinkActionMode) {
    t13 = isMobile ? <button type="button" onClick={() => setIsSearchOpen(true)} aria-label="Search messages in this wave" className="tw-flex tw-min-w-0 tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-left"><div className="tw-size-6 tw-flex-shrink-0 tw-rounded-full tw-ring-1 tw-ring-white/30 tw-ring-offset-1 tw-ring-offset-iron-950 lg:tw-size-9"><WavePicture name={wave.name} picture={wave.picture} contributors={wave.contributors_overview.map(_temp3)} /></div><h1 className="tw-mb-0 tw-ml-3 tw-truncate tw-text-sm tw-font-semibold tw-tracking-tight tw-text-white/95 lg:tw-text-xl">{wave.name}</h1></button> : <><div className="tw-size-6 tw-flex-shrink-0 tw-rounded-full tw-ring-1 tw-ring-white/30 tw-ring-offset-1 tw-ring-offset-iron-950 lg:tw-size-9"><WavePicture name={wave.name} picture={wave.picture} contributors={wave.contributors_overview.map(_temp4)} /></div><h1 className="tw-mb-0 tw-ml-3 tw-truncate tw-text-sm tw-font-semibold tw-tracking-tight tw-text-white/95 lg:tw-text-xl">{wave.name}</h1>{showShareAction && <button type="button" onClick={handleWaveLinkActionClick} aria-label={waveLinkActionLabel} title={waveLinkActionLabel} data-wave-link-action-mode={waveLinkActionMode} className={`tw-ml-2 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-transition tw-duration-150 hover:tw-border-iron-500 hover:tw-bg-iron-800 hover:tw-text-white ${waveLinkActionIconColor}`}>{renderWaveLinkActionIcon()}</button>}<button type="button" onClick={() => setIsSearchOpen(true)} aria-label="Search messages in this wave" className="tw-ml-2 tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-text-iron-200 tw-transition tw-duration-150 hover:tw-border-iron-500 hover:tw-bg-iron-800 hover:tw-text-white"><MagnifyingGlassIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" /></button></>;
    $[32] = handleWaveLinkActionClick;
    $[33] = isMobile;
    $[34] = renderWaveLinkActionIcon;
    $[35] = showShareAction;
    $[36] = wave.contributors_overview;
    $[37] = wave.name;
    $[38] = wave.picture;
    $[39] = waveLinkActionIconColor;
    $[40] = waveLinkActionLabel;
    $[41] = waveLinkActionMode;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== t12 || $[44] !== t13) {
    t14 = <div className="tw-flex tw-min-w-0 tw-items-center">{t12}{t13}</div>;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== wave) {
    t15 = <div className="tw-hidden lg:tw-block"><MyStreamWaveTabsMemeSubmit handleMemesSubmit={handleMemesSubmit} wave={wave} /></div>;
    $[46] = wave;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== handleWaveLinkActionClick || $[49] !== isMobile || $[50] !== renderWaveLinkActionIcon || $[51] !== showShareAction || $[52] !== waveLinkActionIconColor || $[53] !== waveLinkActionLabel || $[54] !== waveLinkActionMode) {
    t16 = isMobile && showShareAction && <button type="button" onClick={handleWaveLinkActionClick} aria-label={waveLinkActionLabel} title={waveLinkActionLabel} data-wave-link-action-mode={waveLinkActionMode} className={`tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-transition tw-duration-150 hover:tw-border-iron-500 hover:tw-bg-iron-800 hover:tw-text-white ${waveLinkActionIconColor}`}>{renderWaveLinkActionIcon()}</button>;
    $[48] = handleWaveLinkActionClick;
    $[49] = isMobile;
    $[50] = renderWaveLinkActionIcon;
    $[51] = showShareAction;
    $[52] = waveLinkActionIconColor;
    $[53] = waveLinkActionLabel;
    $[54] = waveLinkActionMode;
    $[55] = t16;
  } else {
    t16 = $[55];
  }
  const t17 = `tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-iron-200 tw-transition tw-duration-300 ${isRightSidebarOpen ? "tw-rotate-180 desktop-hover:group-hover:tw-translate-x-0.5" : "tw-rotate-0 desktop-hover:group-hover:-tw-translate-x-0.5"}`;
  let t18;
  if ($[56] !== t17) {
    t18 = <ChevronDoubleLeftIcon strokeWidth={2} className={t17} />;
    $[56] = t17;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  let t19;
  if ($[58] !== t18 || $[59] !== toggleRightSidebar) {
    t19 = <button type="button" onClick={toggleRightSidebar} className="tw-group tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-700 tw-shadow-[0_12px_28px_rgba(0,0,0,0.35)] tw-backdrop-blur-sm tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-border-iron-500/80 desktop-hover:hover:tw-bg-iron-700/85 desktop-hover:hover:tw-shadow-[0_16px_34px_rgba(0,0,0,0.4)]" aria-label="Toggle right sidebar">{t18}</button>;
    $[58] = t18;
    $[59] = toggleRightSidebar;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  let t20;
  if ($[61] !== t15 || $[62] !== t16 || $[63] !== t19) {
    t20 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-self-stretch">{t15}{t16}{t19}</div>;
    $[61] = t15;
    $[62] = t16;
    $[63] = t19;
    $[64] = t20;
  } else {
    t20 = $[64];
  }
  let t21;
  if ($[65] !== t14 || $[66] !== t20) {
    t21 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-4 tw-overflow-x-hidden tw-px-2 tw-py-3 sm:tw-px-4">{t14}{t20}</div>;
    $[65] = t14;
    $[66] = t20;
    $[67] = t21;
  } else {
    t21 = $[67];
  }
  let t22;
  if ($[68] !== activeContentTab || $[69] !== setActiveContentTab || $[70] !== wave) {
    t22 = <MyStreamWaveDesktopTabs activeTab={activeContentTab} wave={wave} setActiveTab={setActiveContentTab} />;
    $[68] = activeContentTab;
    $[69] = setActiveContentTab;
    $[70] = wave;
    $[71] = t22;
  } else {
    t22 = $[71];
  }
  let t23;
  if ($[72] !== isMemesWave || $[73] !== isRankWave || $[74] !== nextDecisionTime || $[75] !== timeLeft) {
    t23 = (isMemesWave || isRankWave) && nextDecisionTime && <div className="tw-flex-shrink-0 tw-px-2 sm:tw-px-4"><CompactTimeCountdown timeLeft={timeLeft} /></div>;
    $[72] = isMemesWave;
    $[73] = isRankWave;
    $[74] = nextDecisionTime;
    $[75] = timeLeft;
    $[76] = t23;
  } else {
    t23 = $[76];
  }
  let t24;
  if ($[77] !== t22 || $[78] !== t23) {
    t24 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-border-x-0 tw-border-y tw-border-solid tw-border-iron-800">{t22}{t23}</div>;
    $[77] = t22;
    $[78] = t23;
    $[79] = t24;
  } else {
    t24 = $[79];
  }
  let t25;
  if ($[80] !== t21 || $[81] !== t24) {
    t25 = <div className="tw-flex tw-w-full tw-flex-col tw-bg-iron-950">{t21}{t24}</div>;
    $[80] = t21;
    $[81] = t24;
    $[82] = t25;
  } else {
    t25 = $[82];
  }
  let t26;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => setIsMemesModalOpen(false);
    $[83] = t26;
  } else {
    t26 = $[83];
  }
  let t27;
  if ($[84] !== isMemesModalOpen || $[85] !== wave) {
    t27 = <MemesArtSubmissionModal isOpen={isMemesModalOpen} wave={wave} onClose={t26} />;
    $[84] = isMemesModalOpen;
    $[85] = wave;
    $[86] = t27;
  } else {
    t27 = $[86];
  }
  let t28;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = () => setIsSearchOpen(false);
    $[87] = t28;
  } else {
    t28 = $[87];
  }
  let t29;
  if ($[88] !== handleSearchSelect || $[89] !== isSearchOpen || $[90] !== wave) {
    t29 = <WaveDropsSearchModal isOpen={isSearchOpen} onClose={t28} wave={wave} onSelectSerialNo={handleSearchSelect} />;
    $[88] = handleSearchSelect;
    $[89] = isSearchOpen;
    $[90] = wave;
    $[91] = t29;
  } else {
    t29 = $[91];
  }
  let t30;
  if ($[92] !== t25 || $[93] !== t27 || $[94] !== t29) {
    t30 = <>{" "}{t25}{t27}{t29}</>;
    $[92] = t25;
    $[93] = t27;
    $[94] = t29;
    $[95] = t30;
  } else {
    t30 = $[95];
  }
  return t30;
};
export default MyStreamWaveTabsMeme;
function _temp(decision) {
  return {
    decision_time: decision.timestamp
  };
}
function _temp2(decision_1) {
  return decision_1.timestamp > Time.currentMillis();
}
function _temp3(c) {
  return {
    pfp: c.contributor_pfp
  };
}
function _temp4(c_0) {
  return {
    pfp: c_0.contributor_pfp
  };
}